// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"40de32cb","96":"0da24a6c","101":"b9964f73","249":"44963a28","533":"be44548c","615":"54b8dee6","633":"5721dd23","661":"f3e3672b","673":"9a79f6d7","715":"989a09fe","745":"1c2bb516","754":"f95d0a25","803":"b352b615"}[chunkId] + ".chunk.js";
};